import * as React from 'react';
import { observer } from 'mobx-react';

import { WidgetChannelCreationStore } from 'stores/channelCreationStores';
import { Button } from 'shared/newComponents/buttons';
import { ButtonSize } from 'shared/newEntities/components/Button';
import { ComponentType } from 'shared/entities/components/Component';
import { LoadingStage } from 'shared/entities/meta';

import WidgetCreateURL from './WidgetCreateURL';
import WidgetCreateDesign from './WidgetCreateDesign';

import './WidgetCreate.modules.scss';

type Props = {
  store: WidgetChannelCreationStore;
};

const WidgetCreate: React.FC<Props> = ({ store }) => {
  return (
    <div styleName="widget-create">
      <WidgetCreateURL url={store.url} />
      <WidgetCreateDesign />
      <Button
        size={ButtonSize.lg}
        type={ComponentType.button}
        onClick={store.create}
        isLoading={store.creationStage.value === LoadingStage.LOADING}
        disabled={store.isError}
        fullWidth
      >
        {(t) =>
          t('ChannelsModal.ChannelForm.button', {
            ns: 'newContainers'
          })
        }
      </Button>
    </div>
  );
};

export default observer(WidgetCreate);
